// actions
import { dispatchSetWindowFocus } from '../../components/main/root.action'

window.addEventListener('blur', () => dispatchSetWindowFocus(false))
window.addEventListener('focus', () => dispatchSetWindowFocus(true))
